import { render, staticRenderFns } from "./shop-main.vue?vue&type=template&id=7c9c4116&scoped=true&"
import script from "./shop-main.vue?vue&type=script&lang=js&"
export * from "./shop-main.vue?vue&type=script&lang=js&"
import style0 from "./shop-main.vue?vue&type=style&index=0&id=7c9c4116&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c4116",
  null
  
)

export default component.exports